module.exports = __webpack_public_path__ + "img/google-meet.0e22d91a.png";